import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginPageComponent } from 'src/app/angular-elements/shared/components/login-page/login-page.component';
import { RegistrationService } from '@ptl/account-management';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-pre-login-view',
    templateUrl: './pre-login-view.component.html',
    styleUrls: ['./pre-login-view.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class PreLoginViewComponent extends GlobalShadowStyleDirective implements OnInit {

  /** Registration */
  @Input() registrationUrl: string;

  /** Login */
  @Input() producerLandingPageUrl: string;
  @Input() memberLandingPageUrl: string;
  @Input() consumerLandingPageUrl: string;
  @Input() forgotPasswordUrl: string;

  constructor(
    private matDialog: MatDialog,
    private registrationService: RegistrationService
  ) { 
    super();
  }

  ngOnInit() {
    /** We'll want to have access to this URL elsewhere */
    this.registrationService.setRegistrationStartUrl(this.registrationUrl);
  }

  loginTrigger() {
    const preLoginViewLoginModalId = 'preLoginView_loginModal';

    /** Let the default URL be leveraged */
    this.registrationService.setRegistrationCompleteUrl(null);

    const dialogRef = this.matDialog.open(LoginPageComponent, {
      id: preLoginViewLoginModalId,
      maxHeight: '100vh',
      maxWidth: '650px',
      data: {
        producerLandingPageUrl: this.producerLandingPageUrl,
        memberLandingPageUrl: this.memberLandingPageUrl,
        consumerLandingPageUrl: this.consumerLandingPageUrl,
        forgotPasswordUrl: this.forgotPasswordUrl,
        registrationStartUrl: this.registrationService.getRegistrationStartUrl()
      }
    });

    (this.matDialog.getDialogById(preLoginViewLoginModalId).componentInstance as LoginPageComponent).closeEmitter.subscribe(x => {
      dialogRef.close();
    });
  }

  registerTrigger() {
    window.location.href = `./${this.registrationUrl}`;
  }
}
